import React from "react";

function SuccessPage() {
  return (
    <div className="contact-success">
      <div className="contact-success__icon">
        <i className="fas fa-check"></i>
      </div>
      <h2>Message sent!</h2>
      <p>
        Thanks for getting in touch — we've received your message and will be
        back to you shortly.
      </p>
    </div>
  );
}

export default SuccessPage;
